import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Instalatii from "./pages/Instalatii";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import CallFab from "./components/CallFab";

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white text-gray-900 scroll-smooth">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/instalatii" element={<Instalatii />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <CallFab />
      </div>
    </Router>
  );
}
